import { createContentPropTypes } from '../../helpers/content';

const futureDatedPaymentContent = {
	header: 'Payment date changed',
	description: 'This payment has missed the planned submission date.',
	submissionDateTitle: 'Submission date:',
	settlementDateTitle: 'Earliest estimated settlement date:',
	authoriseButtonLabel: 'Authorise Later',
	cancelButtonLabel: 'Cancel payment',
};

const currentDatedPaymentContent = {
	...futureDatedPaymentContent,
	header: 'Payment date changed',
	description:
		'As you’re authorising this payment after the planned payment date, it will now be submitted and settled on the following dates:',
	submissionDateTitle: 'Submission date:',
	authoriseButtonLabel: 'Accept and authorise',
};

const chapsPaymentContent = {
	header: 'Payment date changed',
	description:
		'As you’re authorising this payment after the cut-off for the planned payment date, we’ve had to recalculate the earliest possible payment date:',
	submissionDateTitle: 'New payment date:',
	authoriseButtonLabel: 'Accept and authorise',
	cancelButtonLabel: 'Cancel payment',
};

export default { futureDatedPaymentContent, currentDatedPaymentContent, chapsPaymentContent };

export const contentPropTypes = createContentPropTypes(currentDatedPaymentContent);
